import React from "react";
// import {FieldTypeProps} from 'sulu-admin-bundle/types';
import FemaleShorts from "../../svgs/FemaleShorts";
import MaleShorts from "../../svgs/MaleShorts";
import FemaleTop from "../../svgs/FemaleTop";
import MaleTop from "../../svgs/MaleTop";
import LeftSock from "../../svgs/LeftSock";
import RightSock from "../../svgs/RightSock";
import { ResourceRequester } from "sulu-admin-bundle/services";

import ColorInput from "./ColorInput";

// <FieldTypeProps<?string>>
export default class UniformSVG extends React.Component {
    constructor(props) {
        super(props);

        const {
            data: { gender, jerseys },
            schemaOptions,
        } = this.props;

        const height = schemaOptions["height"]?.value || "",
            scale = schemaOptions["scale"]?.value || "",
            team = schemaOptions["team"]?.value || "",
            MainColor = schemaOptions["jerseyMainColor"]?.value || "",
            ShortsColor = schemaOptions["jerseyShortsColor"]?.value || "",
            StuttersColor = schemaOptions["jerseyStuttersColor"]?.value || "",
            GoalieColor = schemaOptions["jerseyGoalieColor"]?.value || "";

        const {
            topColor: { custom: jerseyMainColor } = { custom: "" },
            shortsColor: { custom: jerseyShortsColor } = { custom: "" },
            socksColor: { custom: jerseyStuttersColor } = { custom: "" },
            goalKeeper: { custom: jerseyGoalieColor } = { custom: "" },
        } = jerseys?.$mobx?.values[0] && this.props.value
            ? JSON.parse(this.props.value)
            : {};

        const initState = {
            topColor: { custom: jerseyMainColor },
            shortsColor: { custom: jerseyShortsColor },
            socksColor: { custom: jerseyStuttersColor },
            goalKeeper: { custom: jerseyGoalieColor },
            gender: this.props.data.gender || false,
            defaultUniform: false,
            height: height,
            scale: scale,
            team: team,
        };

        const prevState = props.value ? props.value : {};

        this.state = initState;
        // props.value ?
        // 	{...initState, ...prevState}
        // 	: initState;
    }

    componentDidMount() {
        this.hideInputFields();

        if (
            this.props.dataPath === "/homeJerseys" ||
            this.props.dataPath === "/awayJerseys"
        ) {
            this.loadData();
        }
    }

    async loadData() {
        const {
            data: { homeTeamObject, awayTeamObject, homeUniform, awayUniform },
        } = this.props;

        const locale = this.props.router?.attributes?.locale;
        const logoId =
            this.props.dataPath === "/homeJerseys"
                ? homeTeamObject.logo
                : awayTeamObject.logo;
        const uniformId =
            this.props.dataPath === "/homeJerseys" ? homeUniform : awayUniform;

        try {
            const logoImg = await ResourceRequester.get("media", {
                id: logoId,
                locale: locale,
            });
            const uniformData = await ResourceRequester.get("uniform", {
                id: uniformId,
                locale: locale,
            });
            const { topColor, shortsColor, socksColor, goalKeeper } =
                uniformData.raw;
            this.setState((data) => ({
                ...data,
                topColor,
                shortsColor,
                socksColor,
                goalKeeper,
                logo: logoImg.thumbnails["image-150.webp"],
            }));
        } catch (e) {
            console.log(e.message);
        }
    }

    setJersyFields() {
        //jerseyMainColor = '', jerseyShortsColor = '', jerseyStuttersColor = '', jerseyGoalieColor = ''
        const { topColor, shortsColor, socksColor, goalKeeper } = this.state;
        const getClr = [topColor, shortsColor, socksColor, goalKeeper];

        const jerseyArr = [
            "jerseyMainColor",
            "jerseyShortsColor",
            "jerseyStuttersColor",
            "jerseyGoalieColor",
        ];

        jerseyArr.forEach((single, ind) => {
            const input = document.querySelector(`input[id*=${single}]`);

            //https://stackoverflow.com/a/46012210
            const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
                window.HTMLInputElement.prototype,
                "value"
            ).set;
            nativeInputValueSetter.call(input, getClr[ind].custom);

            const ev2 = new Event("input", { bubbles: true });
            input.dispatchEvent(ev2);
        });
    }

    hideInputFields = () => {
        const jersyFields = document.querySelectorAll('[id*="Color"]');

        jersyFields.forEach((el) => {
            el.closest("[class*='item']").style.display = "none";
        });
    };

    handleInternalStateChange = (arrPairs) => {
        const { onChange, onFinish } = this.props;
        const { state, setState } = this;

        const tProp = state;
        const attrVal = arrPairs.value;

        if (arrPairs.type == "custom") {
            switch (arrPairs.name) {
                case "top":
                    tProp.topColor.custom = attrVal;
                    break;
                case "shorts":
                    tProp.shortsColor.custom = attrVal;
                    break;
                case "socks":
                    tProp.socksColor.custom = attrVal;
                    break;
                case "goalKeeper":
                    tProp.goalKeeper.custom = attrVal;
                    break;
            }
        }

        const newState = {
            ...state,
            ...tProp,
        };

        this.setJersyFields();

        onChange(JSON.stringify(newState));
        onFinish();
    };

    render = () => {
        const {
            topColor,
            shortsColor,
            socksColor,
            goalKeeper,
            gender,
            height,
            scale,
        } = this.state;
        const {
            dataPath,
            error,
            disabled,
            onChange,
            value,
            onFinish,
            onSuccess,
            schemaOptions,
        } = this.props;

        const genderFlagMale = gender === 1;

        const containerCSS = {
            display: "flex",
            justifyContent: "space-between",
            height: height || null,
        };

        const leftPanelCSS = {
            width: "40%",
        };

        const rightPanelCSS = {
            width: "60%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            scale: scale || null,
        };

        const socksCSS = {
            display: "flex",
            gap: "20px",
        };
        const component = this.props.dataPath.replace(/^\/+/g, "");
        return (
            <div
                style={{
                    padding: "31px 37px 70px",
                    backgroundColor: "#fff",
                }}
            >
                <div
                    className="unfiorm-container"
                    style={containerCSS}
                    datapath={dataPath}
                    value={JSON.stringify(this.state)}
                >
                    <div className="left-panel" style={leftPanelCSS}>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <p
                                style={{
                                    fontSize: "14px",
                                    fontWeight: "700",
                                    marginRight: "24px",
                                }}
                            >
                                {component === "homeJerseys"
                                    ? this.props.data.homeTeamName
                                    : this.props.data.awayTeamName}
                            </p>
                            <img
                                style={{ maxWidth: "35px" }}
                                src={this.state.logo}
                            />
                        </div>
                        <ColorInput
                            name={"top"}
                            label={"Trikot"}
                            custom={topColor?.custom}
                            dataPath={`${dataPath}#top`}
                            onChange={this.handleInternalStateChange}
                            style={{ marginTop: "10px" }}
                            disable={
                                component === "homeJerseys" ||
                                component === "awayJerseys"
                                    ? true
                                    : false
                            }
                        />
                        <ColorInput
                            name={"shorts"}
                            label={"Hose / Rock"}
                            custom={shortsColor?.custom}
                            dataPath={`${dataPath}#shorts`}
                            onChange={this.handleInternalStateChange}
                            style={{ marginTop: "10px" }}
                            disable={
                                component === "homeJerseys" ||
                                component === "awayJerseys"
                                    ? true
                                    : false
                            }
                        />
                        <ColorInput
                            name={"socks"}
                            label={"Stutzen"}
                            custom={socksColor?.custom}
                            dataPath={`${dataPath}#socks`}
                            onChange={this.handleInternalStateChange}
                            style={{ marginTop: "10px" }}
                            disable={
                                component === "homeJerseys" ||
                                component === "awayJerseys"
                                    ? true
                                    : false
                            }
                        />

                        <ColorInput
                            name={"goalKeeper"}
                            label={"Torwart"}
                            custom={goalKeeper?.custom}
                            dataPath={`${dataPath}#socks`}
                            onChange={this.handleInternalStateChange}
                            style={{ marginTop: "25px" }}
                            disable={
                                component === "homeJerseys" ||
                                component === "awayJerseys"
                                    ? true
                                    : false
                            }
                        />
                    </div>

                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                        }}
                    >
                        <div className="right-panel" style={rightPanelCSS}>
                            <div className="trousers-top">
                                {!genderFlagMale && (
                                    <FemaleTop
                                        fill={
                                            topColor?.custom || topColor?.base
                                        }
                                        stroke="black"
                                    />
                                )}
                                {genderFlagMale && (
                                    <MaleTop
                                        fill={
                                            topColor?.custom || topColor?.base
                                        }
                                        stroke="black"
                                    />
                                )}
                            </div>

                            <div className="short">
                                {!genderFlagMale && (
                                    <FemaleShorts
                                        fill={
                                            shortsColor?.custom ||
                                            shortsColor?.base
                                        }
                                        stroke="black"
                                    />
                                )}
                                {genderFlagMale && (
                                    <MaleShorts
                                        fill={
                                            shortsColor?.custom ||
                                            shortsColor?.base
                                        }
                                        stroke="black"
                                    />
                                )}
                            </div>

                            <div className="socks" style={socksCSS}>
                                <LeftSock
                                    fill={
                                        socksColor?.custom || socksColor?.base
                                    }
                                    stroke="black"
                                />
                                <RightSock
                                    fill={
                                        socksColor?.custom || socksColor?.base
                                    }
                                    stroke="black"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
}
